// shameless https://www.telerik.com/blogs/debouncing-and-throttling-in-javascript
const timers = { };

export default function debounce(func, delay, id = 'default') {
  const timerId = timers[id];
  // Cancels the setTimeout method execution
  clearTimeout(timerId);

  // Executes the func after delay time.
  // If setTimeout is already scheduled, no need to do anything
  timers[id] = setTimeout(func, delay);
}
